import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { List } from 'lucide-react';
import type { GroupedAlert } from '@kirin/api-client/contracts/alerts';
import { AlertDetailCard } from '@/components/grouped-alerts/AlertDetailCard';

interface TableRowExpandedProps {
  row: GroupedAlert;
}

/**
 * Expanded row content for the user alerts DataTable.
 * Matches the legacy AlertsTable expansion exactly:
 * AlertDetailCard + "Show Occurrences" button navigating to the occurrences route.
 * Preserves URL search params so the DataTable can re-hydrate its state on modal close.
 */
export function TableRowExpanded({ row }: TableRowExpandedProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const occurrencesPathname = `/dashboard/alerts/${encodeURIComponent(row.alertKey)}/occurrences`;

  return (
    <div className="min-w-0 max-w-full">
      <AlertDetailCard
        alert={row}
        scope={{ kind: 'account' }}
        alertKey={row.alertKey}
      />
      <div className="mt-2 flex justify-start">
        <Button
          variant="outline"
          size="sm"
          onClick={e => {
            e.stopPropagation();
            navigate({
              pathname: occurrencesPathname,
              search: location.search,
            });
          }}
        >
          <List className="h-4 w-4 mr-2" />
          Show Occurrences
        </Button>
      </div>
    </div>
  );
}
